import React, { Children } from "react";

import { CollapsibleSection } from "@sportal/cdk";

import "./DeviceGroup.scss";

export function DeviceGroup({ defaultExpanded = true, children }) {
  const [header, ...restChildren] = Children.toArray(children);

  return (
    <CollapsibleSection
      defaultOpened={defaultExpanded}
      className="device-group"
      header={header}
      content={restChildren}
    />
  );
}
